export default `Circumcircle Variant

  float de(vec3 p){
    float width = 1.;
    float height = 1.;

    return max(q.y - height, max(q.x*sqrt(3)*0.5 + q.z*0.5, q.z) - width);
  }

Incircle Variant

  float de(vec3 p){
    float width = 1.;
    float height = 1.;
    vec3 q = abs(p);

    return max(q.y - height, max(q.x*sqrt(3)*0.5 + q.z*0.5, q.z) - (width*sqrt(3)*0.5));
  }`